import ConfirmDialog from '../../common/components/ConfirmDialog';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onProceed: () => void;
};

export default function ExistingAccountDialog({ isOpen, onClose, onProceed }: Props) {
    return (
        <ConfirmDialog
            title="You already have an account"
            subtext="This email is already registered with TrainHeroic. Log in with your existing password to convert your account to a coach trial."
            isOpen={isOpen}
            handleClose={onClose}
            proceed={onProceed}
            proceedButtonText="Log In and Convert"
            proceedButtonClassName="coach-trial-convert-link"
        />
    );
}
